import { lazy } from "react";
import { RouteObject } from "react-router-dom";
const PersonifyOutlet = lazy(() => import("../components"));

const Personify = lazy(() => import("../components/Personify"));
const MemberEnrollmentSurveyForm = lazy(
  () => import("../components/MemberEnrollment/MemberEnrollmentSurveyForm")
);
const PersonifyConfigRoute: RouteObject = {
  path: "/settings/modules/personify",
  element: <PersonifyOutlet />,
  children: [
    {
      path: "",
      element: <Personify />,
    },
    {
      path: "enrollment-form",
      element: <MemberEnrollmentSurveyForm />,
    },
  ],
};

export default PersonifyConfigRoute;
